class $99668942ecd442ed$var$AiForm extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.render();
        this.setupEventListeners();
        // Autofocus when loaded
        this.focus();
    }
    render() {
        this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
        }
        form {
          display: flex;
          align-items: center;
          background: rgba(0, 100, 0, 0.3);
          padding: 1em;
          border-radius: 0.33rem;
          color: rgba(0, 255, 0, 0.66);
        }
        #input {
          flex-grow: 1;
          background-color: transparent;
          outline: none;
          border: none;
          color: inherit;
          font-family: inherit;
          font-size: inherit;
          min-width: 1ch;
        }
        .message {
          opacity: 0.5;
        }
      </style>
      <form>
        <input name="input" type="text" id="input" autocomplete="off" />
      </form>
    `;
    }
    setupEventListeners() {
        const form = this.shadowRoot.querySelector("form");
        const input = this.shadowRoot.getElementById("input");
        form.addEventListener("submit", (e)=>{
            e.preventDefault();
            const value = input.value;
            this.dispatchEvent(new CustomEvent("ai-form-submit", {
                detail: value
            }));
        });
        input.addEventListener("input", ()=>{
            input.style.width = `${input.value.length + 1}ch`;
        });
    }
    setPlaceholder(text) {
        const input = this.shadowRoot.getElementById("input");
        input.setAttribute("placeholder", text);
    }
    focus() {
        const input = this.shadowRoot.getElementById("input");
        input.focus();
    }
    reset() {
        const input = this.shadowRoot.getElementById("input");
        input.value = "";
        input.classList.remove("message");
        input.removeAttribute("disabled");
        this.focus();
    }
}
customElements.define("ai-form", $99668942ecd442ed$var$AiForm);


class $57dc947be0c9d2ad$var$AiTerminal extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.render();
        this.setupMutationObserver();
    }
    render() {
        this.shadowRoot.innerHTML = `
            <style>
                a {
                    border: 1px solid rgba(0, 100, 0, 0.6);
                    border-bottom-width: 4px;
                    background-color: rgba(0, 100, 0, 0.6);
                    color: rgba(0, 255, 0, 0.8);
                    display: inline-block;
                    padding: 0.8em 1em 0.7em 1em;
                    text-decoration: none;
                    line-height: 1;
                    border-radius: 0.33rem;
                    cursor: pointer;
                    transition: background-color 0.3s, color 0.3s;
                }
                a:hover {
                    background-color: rgba(0, 100, 0, 0.8);
                }
                :host {
                    display: block;
                    flex-direction: column;
                    font-family: monospace;
                    font-size: large;
                    line-height: 1.3;
                    font-weight: 400;
                    max-width: 100%;
                    word-wrap: break-word;
                }
                #terminal {
                    max-width: 42rem;
                    margin: 0 auto 0;
                    padding: 1rem;
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }
                #output {
                    white-space: pre-wrap;
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    line-height: 1.5;
                }
                #output p {
                    margin: 0;
                }
                ai-form {
                    display: flex;
                    flex-direction: column;
                    flex-grow: 1;
                }
            </style>
            <div id="terminal">
                <div id="output"></div>
            </div>
        `;
    }
    setupMutationObserver() {
        const observer = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                if (mutation.type === "childList") {
                    const addedNodes = mutation.addedNodes;
                    for(let i = 0; i < addedNodes.length; i++)if (addedNodes[i].nodeName.toLowerCase() === "ai-form") {
                        this.setupEventListeners(addedNodes[i]);
                        observer.disconnect(); // Stop observing once we've found the ai-form
                        return;
                    }
                }
            });
        });
        observer.observe(this.shadowRoot, {
            childList: true,
            subtree: true
        });
    }
    setupEventListeners(form) {
        if (!form) return;
        form.addEventListener("ai-form-submit", (e)=>{
            const command = e.detail;
            this.processCommand(command);
        });
    }
    appendOutput(text) {
        this._typeText(text);
    }
    async _typeText(html, delay = 2, pause = 100) {
        const output = this.shadowRoot.getElementById("output");
        // Parse the HTML string into a DOM tree
        const temp = document.createElement("div");
        temp.innerHTML = html;
        // Recursive function to type node and append to output
        const typeNode = async (node, parent)=>{
            if (node.nodeType === Node.TEXT_NODE) {
                const text = node.textContent;
                const typedNode = document.createTextNode("");
                parent.appendChild(typedNode);
                for(let i = 0; i < text.length; i++){
                    typedNode.textContent += text.charAt(i);
                    await new Promise((resolve)=>setTimeout(resolve, delay));
                }
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                const elementNode = document.createElement(node.tagName.toLowerCase());
                // Copy attributes to new element
                for (let attr of node.attributes)elementNode.setAttribute(attr.name, attr.value);
                parent.appendChild(elementNode);
                for (let child of node.childNodes)await typeNode(child, elementNode);
            }
            // Pause after typing node
            await new Promise((resolve)=>setTimeout(resolve, pause));
        };
        for (let node of temp.childNodes)await typeNode(node, output);
        // Scroll to bottom after typing completes
        const terminal = this.shadowRoot.getElementById("terminal");
        terminal.scrollTop = terminal.scrollHeight;
    }
    typeMessage(message) {
        this._typeText(message);
    }
    processCommand(command) {
        this.appendOutput("<p>I'm creating your account...</p>");
        this.appendOutput(`For your safety, I'll send your temporary password to your WhatsApp."
      `);
    }
}
customElements.define("ai-terminal", $57dc947be0c9d2ad$var$AiTerminal);



var $3127060cff82451e$exports = {};
class $3127060cff82451e$var$AiNav extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        this.render();
    }
    render() {
        const { origin: origin, host: host, pathname: pathname } = window.location;
        const pathSegments = pathname.split("/").filter((segment)=>segment !== "");
        this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: flex;
          align-items: center;
          padding: 10px;
          color: rgba(0, 255, 0, 0.2) !important;
        }
        a {
          text-decoration: none;
          color: rgba(0, 255, 0, 0.3) !important;
        }
        a:hover {
          text-decoration: underline;
        }
      </style>
      <nav>
        <a href="${origin}">${host}</a>
        ${pathSegments.map((segment, index)=>`
          <span>/</span>
          <a href="${origin}/${pathSegments.slice(0, index + 1).join("/")}">${segment}</a>
        `).join("")}
      </nav>
    `;
    }
}
customElements.define("ai-nav", $3127060cff82451e$var$AiNav);
$3127060cff82451e$exports = $3127060cff82451e$var$AiNav;


var $82bc60706381ca30$exports = {};
class $82bc60706381ca30$var$AiAssistants extends HTMLElement {
    connectedCallback() {
        this.render();
    }
    render() {
        this.innerHTML = `
      <style>
        ai-assistants {
          display: flex;
        }
        #assistants {
          display: flex;
          flex-direction: row;
          gap: 1em;
        }
      </style>
      <div id="assistants">
        <a href="/assistants/shopify">shopify.com</a>
        <a href="/assistants/youtube">youtube.com</a>
      </div>
    `;
    }
}
customElements.define("ai-assistants", $82bc60706381ca30$var$AiAssistants);
$82bc60706381ca30$exports = $82bc60706381ca30$var$AiAssistants;


const $3d2f1ba24cab85b7$var$content = {
    "/": `
  <p>I'm your AI Assistant for any web site</p>
  <p>What web site do you want to interact with?</p>
  <ai-form id="input-line"></ai-form>
  <p>Or try one of these:</p>
  <ai-assistants></ai-assistants>
  `,
    "/assistants": `
  <p>How can I help you today?</p>
  <ai-assistants></ai-assistants>
  <p>Or try any other web site you want:</p>
  <ai-form id="input-line"></ai-form>
  `,
    "/assistants/shopify": `
  <p>Hey, I'm your shopify.com assistant.</p>
  <p>How can I help you today?</p>
  <p><a href="/assistants/shopify/build-store">Build a store</a>
  </p>
  `,
    "/assistants/youtube": `
  <p>Hey, I'm your youtube.com assistant.</p>
  <p>How can I help you today?</p>
  <p><a href="/assistants/youtube/transcript">Get video transcription</a>
  </p>
  `,
    "/assistants/shopify/build-store": `
  <p>To build your store, first I'll create a Shopify account for you.</p>
  <p>What is your e-mail?</p>
  <ai-form></ai-form>
  `
};
const $3d2f1ba24cab85b7$var$behavior_id = "1234567890";
document.addEventListener("DOMContentLoaded", ()=>{
    const terminal = document.querySelector("ai-terminal");
    const notFound = `<p>...</p>
  <p>Sorry, I'm too busy right now, your request is in the queue.</p>
  <p>For your convenience, I'll send you a WhatsApp message when it's ready.</p>
  <p><a href="https://wa.me/5531996975408?text=${encodeURI(`KEY: ${$3d2f1ba24cab85b7$var$behavior_id}\n\nHey Guima, this is the key of my request, please informe me when it's ready.`)}" target="_blank">Click to be informed</a></p>`;
    const { pathname: pathname } = window.location;
    const initialMessage = $3d2f1ba24cab85b7$var$content[pathname] || notFound;
    terminal.typeMessage(initialMessage);
    // Override the processCommand method
    terminal.processCommand = (command)=>{
        const answer = {
            "/": `<p>I'm learning about ${command}</p>
      <p>You can chat with it in your WhatsApp.</p>
      <p><a href="https://wa.me/5531996975408?text=${encodeURI(`KEY: ${$3d2f1ba24cab85b7$var$behavior_id}\n\nHey Guima, this is the key to access my AI Assistant.`)}" target="_blank">Click to chat</a></p>
      `,
            "/assistants/shopify/build-store": `<p>I'm creating your store...</p>
      <p>For your safety, I'll send your temporary password to your WhatsApp.</p>
      <p><a href="https://wa.me/5531996975408?text=${encodeURI(`KEY: ${$3d2f1ba24cab85b7$var$behavior_id}\n\nHey Guima, this is my key to get my Shopify store password.`)}" target="_blank">Get your temporary password</a></p>
      `
        };
        const message = answer[pathname] || "I'm sorry, I don't understand.";
        // Here you can add logic to process user commands
        terminal.appendOutput(message);
    };
});


//# sourceMappingURL=index.f817c445.js.map
